// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyProps } from "@insite/mobius/Typography";
import { addressInfoDisplayStyles } from "@sc/Overrides/Components/AddressInfoDisplay";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const addressFontStyle: TypographyProps = {
    as: "p",
    css: css`
        font-size: 14px;
        line-height: 22px;
        font-weight: ${fontConfig.weight.regular};
    `,
};
addressInfoDisplayStyles.customerNumberText = { ...addressFontStyle };

addressInfoDisplayStyles.customerNameText = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.attentionText = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.companyNameText = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.address1Text = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.address2Text = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.address3Text = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.address4Text = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.cityStatePostalCodeText = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.countryText = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.faxText = {
    ...addressFontStyle,
};

addressInfoDisplayStyles.postalCodeText = {
    css: css`
        font-weight: ${fontConfig.weight.regular};
    `,
};

addressInfoDisplayStyles.stateText = {
    css: css`
        font-weight: ${fontConfig.weight.regular};
    `,
};

addressInfoDisplayStyles.cityText = {
    css: css`
        font-weight: ${fontConfig.weight.regular};
    `,
};

addressInfoDisplayStyles.phoneText = mergeWithCss(addressFontStyle, {
    css: css`
        margin-top: 8px;
    `,
});

addressInfoDisplayStyles.emailText = mergeWithCss(addressFontStyle, {
    css: css`
        margin-top: 4px;
    `,
});
